import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Box from "../Home/Box.jsx";
import "./Gallery.css";
import { sectionsGalleryData } from "./SectionsGalleryData.jsx";

// Other images
import TopImage from "../../assets/Gallery/Other/jpeg-optimizer_Header.jpeg";

export default function Gallery() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="home-wrapper">
      <Container style={{ paddingLeft: "4vw", paddingRight: "4vw" }}>
        <Row>
          <Col>
            <Box title="Photo Gallery" />
            <br />
            <Row>
              <center>
            <img src={TopImage} className="contact-image" alt="flute alliance" />
              </center>
            </Row>
          </Col>
        </Row>
        {windowWidth < 1090 ? (
          <Row>
            <Col>
              {sectionsGalleryData.map(section => (
                <React.Fragment key={section.sectionName}>
                  <br />
                  <br />
                  <Row className="title">{section.sectionName}</Row>
                  {section.images.map((image, index) => (
                    <Row key={index} className="gallery-row-of-images">
                      <Col className="d-flex justify-content-center">
                        <img
                          src={image}
                          style={{ width: '100%' }}
                          alt={`${index + 1}`}
                          className="img-fluid gallery-image"
                        />
                        {image.subtitle && <div className="subtitle">{image.subtitle}</div>}
                      </Col>
                    </Row>
                  ))}
                </React.Fragment>
              ))}
            </Col>
            <br />
          </Row>
        ) : (
          sectionsGalleryData.map(section => (
            <Row key={section.sectionName} className="gallery-outer-row-section">
              <Col>
                <Row className="title">{section.sectionName}</Row>
                {section.imagesPerRow.map((imagesPerRow, rowIndex) => (
                  <Row key={rowIndex} className="gallery-row-of-images">
                    {section.images.slice(rowIndex * imagesPerRow, (rowIndex + 1) * imagesPerRow).map((image, index) => (
                      <Col key={index} xs={12 / imagesPerRow} className="d-flex justify-content-center">
                        <img
                          src={image}
                          style={{ width: `${imagesPerRow === 1 ? 40 : 100}%` }}
                          alt={`${index + 1}`}
                          className="img-fluid gallery-image"
                        />
                        {image.subtitle && <div className="subtitle">{image.subtitle}</div>}
                      </Col>
                    ))}
                  </Row>
                ))}
              </Col>
            </Row>
          ))
        )}
      </Container>
    </div>
  );
}

